module.exports = __webpack_public_path__ + "fa-brands-400.c862e94cbef741d18838.svg";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-brands-400.svg
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-brands-400.svg
// module chunks = styles